<template>
  <f7-page name="roominspectiondetails">
    <div class="list-box week-report-list-box" ref="listBox">
      <module-filter @change="onModuleChange"></module-filter>
      <picker-navbar @checkStatus="onCheckStatus" :numShowcheck="checkedNum"></picker-navbar>
      <date-picker @submit="search"></date-picker>
      <f7-list>
        <f7-list-item
          :title="item.list_name"
          v-for="(item,index) in items"
          :key="index"
          @change="onChange(item)"
          :checkbox="true"
          :checked="item.isChecked"
        ></f7-list-item>
      </f7-list>
    </div>
    <transition name="footer-box">
      <div class="list_foot" v-show="isCheckedInAll">
        <div class="bar_foot" @click="push">推送到邮箱</div>
      </div>
    </transition>
  </f7-page>
</template>

<script>
import { f7Page } from "framework7-vue";
import DatePicker from "@/components/picker/DatePicker";
import PickerNavbar from "@/components/navbar/PickerNavbar";
import ModuleFilter from "@/components/search/ModuleFilter";
import { list2, pushMail2 } from "@/api/report";

export default {
  data() {
    return {
      items: [],
      modulesUuid: "device",
      searchDate: null
    };
  },
  components: {
    DatePicker,
    PickerNavbar,
    ModuleFilter,
    [f7Page.name]: f7Page
  },
  mounted() {
    document.title = "Shopfloor IT Devices Check";
    let dateObj = new Date();
    let date = {
      year: dateObj.getFullYear(),
      month: dateObj.getMonth()+1
    };
    this.search(date);
  },
  methods: {
    search(data) {
      this.searchDate = data;
      this.$f7.preloader.show();
      list2(data, this.modulesUuid)
        .then(({data}) => {
          this.items=data.map(e => {
            return {
              id: e.id,
              list_name: e.reportName,
              isChecked: false,
              file: e.reportName
            }
          });
        })
        .finally(() => {
          this.$f7.preloader.hide();
        });
    },
    onModuleChange(value) {
      this.modulesUuid = value;
      this.search(this.searchDate);
    },
    push() {
      let data=this.items.filter(item => item.isChecked).map(e=>e.id);
      this.$f7.preloader.show();
      pushMail2({ ids: data.join(";") }, this.modulesUuid).then(res => {
        if (res.status === 10000) {
          this.$f7.preloader.hide();
          this.$f7ready(f7 => {
            f7.dialog.alert(
              "亲，报表Excel已经在抵达你的邮箱的路上了！",
              "提示"
            );
            this.items.forEach(item => {
              item.isChecked = false;
            });
          });
        }else{
          this.$f7.preloader.hide();
          this.$f7.dialog.alert(res.msg, "温馨提示", () => {
                WeixinJSBridge.invoke("closeWindow");
              });
        }
      });
    },
    onChange(item) {
      item.isChecked = !item.isChecked;
    },
    onCheckStatus(value) {
      if (value) {
        this.items.forEach(item => {
          item.isChecked = true;
        });
      } else {
        this.items.forEach(item => {
          item.isChecked = false;
        });
      }
    }
  },
  computed: {
    checkedNum() {
      return this.items.filter(item => item.isChecked).length;
    },
    isCheckedInAll() {
      return this.items.filter(item => item.isChecked).length > 0;
    }
  }
};
</script>
<style lang="scss">
/* 覆盖 AnnualReport.vue 中全局 .list-box 的 translateY(-44px)，保证模块筛选条一直可见 */
.week-report-list-box {
  transform: none !important;
}
</style>
